import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import React, { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { defaultColorPallete } from "utils";
import ErrorOutlineTwoToneIcon from "@mui/icons-material/ErrorOutlineTwoTone";
import { DEFAULT_HEIGTH_TO_NAVBAR_AND_CHAT_HEADER } from "utils/constants";
import useToggleState from "utils/hooks/useToggleState";
import showSnackbar from "utils/showSnackbar";

type Props = {
  selectedConversationId: string;
  onConversationFinish: (args: {
    conversationId: string;
    categorizedAt: Date;
  }) => void;
};

export default function SuggestFinishAlert({
  selectedConversationId,
  onConversationFinish,
}: Props) {
  const [visible, setVisible] = useState(true);
  const [endingConversation, setEndingConversation] = useToggleState(false);

  const finishConversation = async () => {
    setEndingConversation();
    try {
      await onConversationFinish({
        conversationId: selectedConversationId,
        categorizedAt: new Date(),
      });
      setEndingConversation();
      setVisible(false)
      showSnackbar("Conversa finalizada com sucesso!");
    } catch (error) {
      showSnackbar("Algo deu errado ao finalizar a conversa!", "error");
      console.error("Error ending conversation", error);
      setEndingConversation();
    }
  };

  const handleClick = () => {
    if (!endingConversation) {
      return finishConversation();
    }
  };

  if (!visible) return null;

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      gap={2}
      bgcolor="white"
      top={`${DEFAULT_HEIGTH_TO_NAVBAR_AND_CHAT_HEADER}px`}
      left={`${DEFAULT_HEIGTH_TO_NAVBAR_AND_CHAT_HEADER}px`}
      position="absolute"
      borderBottom="1px solid"
      borderLeft="1px solid"
      borderRight="1px solid"
      borderColor={defaultColorPallete.neutral.main}
      borderRadius="0px 0px 11px 11px"
      minWidth="600px"
      px={2}
      py={1.5}
      zIndex={1000}
      boxShadow="0px 2px 6px rgba(0, 0, 0, 0.05)"
    >
      {endingConversation ? (
        <Box display="inline-flex" alignItems="center" gap={1}>
          Finalizando Conversa...
          <CircularProgress size={12} />
        </Box>
      ) : (
        <Box display="flex" alignItems="center" gap={1}>
          <ErrorOutlineTwoToneIcon
            sx={{ color: defaultColorPallete.primary.main }}
            fontSize="small"
          />
          <Typography fontSize="0.85rem" color="textSecondary">
            Percebemos que esta conversa pode ter sido concluída. Se desejar
            finalizá-la, é só{" "}
            <Typography
              component="span"
              color={endingConversation ? "textSecondary" : "primary"}
              sx={{
                textDecoration: endingConversation ? "none" : "underline",
                cursor: endingConversation ? "default" : "pointer",
              }}
              onClick={handleClick}
            >
              "clicar aqui"
            </Typography>
            .
          </Typography>
        </Box>
      )}
      <IconButton size="small" onClick={() => setVisible(false)}>
        <CloseIcon sx={{ fontSize: "1rem" }} />
      </IconButton>
    </Box>
  );
}
